/* import __COLOCATED_TEMPLATE__ from './legals-list-item.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { htmlSafe } from '@ember/template';
import { showModal } from "sh-www/utils/modal-controls";
import { absoluteStoryhunterUrl } from "sh-www/utils/url";
import clsx from 'clsx';

const CALENDAR_OPTIONS = {
  sameDay: '[Today at] h:mma',
  lastDay: '[Yesterday at] h:mma',
  lastWeek: '[Last] dddd [at] h:mma',
  sameElse: 'D MMM YYYY [at] h:mma',
};

export default class LegalsListItem extends Component {
  @service('commands/company-commands') companyCommandService;
  @service media;
  @service session;

  @tracked isContentShowing = false;
  @tracked isContentMarkup = false;
  @tracked showVerboseDate = false;

  get createdAtClasses() {
    return clsx(
      'legal-list-item__created-at',
      this.args.variant && `legal-list-item__created-at--${this.args.variant}`,
      'lsg-medium-gray',
    );
  }

  get containerClasses() {
    return clsx(
      'legal-list-item__container',
      this.args.variant && `legal-list-item__container--${this.args.variant}`,
    );
  }

  get titleClasses() {
    return clsx(
      'legal-list-item__title',
      this.args.variant && `legal-list-item__title--${this.args.variant}`,
    );
  }

  get calendarOptions() {
    return CALENDAR_OPTIONS;
  }

  get isDefaultLegal() {
    return Boolean(this.args.legal.isDefault);
  }

  get legalContent() {
    const { content } = this.args.legal;
    return this.isContentMarkup
      ? content
      : htmlSafe(content);
  }

  get legalCreatedAt() {
    return this.args.legal.createdAt;
  }

  get legalTitle() {
    return this.args.legal.title;
  }

  get markupToggleButtonText() {
    return this.isContentMarkup
      ? 'Show plain text'
      : 'Show markup';
  }

  get menuDropdownOptions() {
    const menuOptions = [];

    if (this.isContentShowing) {
      menuOptions.push({
        title: 'Hide',
        onClick: () => this.onChangeLegalView(false),
      });
    } else {
      menuOptions.push({
        title: 'View',
        onClick: () => this.onChangeLegalView(true),
      });
    }

    if (this.args.hasAdminOrCompanyAdminPermission && !this.isDefaultLegal && this.args.makeDefaultLegalTask) {
      menuOptions.push({
        title: 'Make Default',
        onClick: () => this.onMakeDefaultClicked(),
      });
    }

    menuOptions.push({
      title: 'Download as PDF',
      onClick: () => this.onDownloadPDFClicked(),
    });

    return menuOptions;
  }

  @action
  onToggleMarkupClicked() {
    this.isContentMarkup = !this.isContentMarkup;
  }

  @action
  onMakeDefaultClicked() {
    const createdDate = new Date(this.legalCreatedAt).toLocaleDateString();
    const company = this.args.company;
    const legal = this.args.legal;
    const modalModel = {
      titleText: 'Set as default legal agreement?',
      bodyText: `Are you sure you want to set "${this.legalTitle}" (${createdDate}) as your default legal agreement?`,
      actionButtonText: 'Make Default',
      cancelButtonText: 'Cancel',
      width: 'medium',
      confirmAction: () => {
        this.args.makeDefaultLegalTask.perform(company.id, legal.id);
      },
    };

    showModal(this, 'confirmation', modalModel);
  }

  @action
  onChangeLegalView(viewState) {
    this.isContentShowing = viewState;
  }

  @action
  onShowVerboseDateClicked() {
    this.showVerboseDate = !this.showVerboseDate;
  }

  @action
  onDownloadPDFClicked() {
    window.open(absoluteStoryhunterUrl(`/legals/${this.args.legal.id}/download`));
  }
}
